import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCheck, CalendarClock } from "lucide-react";
import { motion } from "framer-motion";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function KioskHome() {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({ clinic_name: "Clínica", logo_url: null });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="kiosk-mode min-h-screen bg-white flex flex-col items-center justify-center p-8">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-full max-w-4xl mx-auto text-center"
      >
        {/* Logo */}
        <motion.div variants={itemVariants} className="mb-12">
          {settings.logo_url ? (
            <img
              src={settings.logo_url.startsWith("http") ? settings.logo_url : `${API_URL}${settings.logo_url}`}
              alt="Logo"
              className="h-32 w-auto mx-auto mb-6 object-contain"
            />
          ) : (
            <div className="h-24 w-24 bg-[#00357C] rounded-2xl mx-auto mb-6 flex items-center justify-center">
              <span className="text-white font-bold text-4xl font-['Outfit']">
                {settings.clinic_name?.charAt(0) || "C"}
              </span>
            </div>
          )}
          <p className="text-2xl md:text-3xl text-slate-500">
            Bem-vindo ao Autoatendimento
          </p>
        </motion.div>

        {/* Action Cards */}
        <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          <button
            data-testid="kiosk-checkin-btn"
            onClick={() => navigate("/identify/checkin")}
            className="kiosk-action-card group"
          >
            <div className="w-24 h-24 rounded-full bg-[#00357C]/10 flex items-center justify-center group-hover:bg-[#00357C]/20 transition-colors">
              <UserCheck className="kiosk-icon w-12 h-12 text-[#00357C]" strokeWidth={1.5} />
            </div>
            <div>
              <h2 className="text-3xl font-semibold text-slate-800 mb-2 font-['Outfit']">
                Confirmar Presença
              </h2>
              <p className="text-xl text-slate-500">
                Já tem consulta agendada para hoje
              </p>
            </div>
          </button>

          <button
            data-testid="kiosk-reschedule-btn"
            onClick={() => navigate("/identify/reschedule")}
            className="kiosk-action-card group"
          >
            <div className="w-24 h-24 rounded-full bg-[#00357C]/10 flex items-center justify-center group-hover:bg-[#00357C]/20 transition-colors">
              <CalendarClock className="kiosk-icon w-12 h-12 text-[#00357C]" strokeWidth={1.5} />
            </div>
            <div>
              <h2 className="text-3xl font-semibold text-slate-800 mb-2 font-['Outfit']">
                Remarcar Consulta
              </h2>
              <p className="text-xl text-slate-500">
                Alterar data ou horário
              </p>
            </div>
          </button>
        </motion.div>

        {/* Footer */}
        <motion.p variants={itemVariants} className="mt-16 text-lg text-slate-400">
          Toque em uma opção para continuar
        </motion.p>
      </motion.div>
    </div>
  );
}
